<template>
    <div class="alert-banner-container">
        <div class="alert-banner">
            <div class="icon">
                <img src="../assets/excited-circle.svg" />
            </div>
            <div class="text">
                <span class="title">
                    {{ persistentAlert.alertMessage }}
                </span>
                {{ persistentAlert.alertMessageDetails }}
            </div>
            <div class="x-button" @click="dismissBanner">
                <img src="../assets/xmark.svg" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { isNullOrUndefined } from "@/shared/helpers"

export default {
    methods: {
        dismissBanner() {
            this.$emit("dismissAlert");
        }
    },
    computed: {
        ...mapGetters([
            "getCurrentPersistentAlert"
        ]),
        persistentAlert() {
            return this.getCurrentPersistentAlert;
        }
    }
}
</script>

<style scoped>
.alert-banner-container {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    min-height: 40px;
    z-index: 2;
}

.alert-banner {
    width: 100%;
    min-height: 40px;
    background-color: #c1181a;
    color: white;
    display: flex;
    flex-direction: row;
    padding: 14px 16px;
    font-size: 14px;
    font-family: 'Roboto';
}

.text {
    padding: 0px 12px;
    width: 100%;
    text-align: left;
}

.title {
    font-weight: 700;
}

.x-button:hover {
    cursor: pointer;
}
</style>